interface IWeektableWeekTotalCellProps {
    projectID: string;
    weekTotal: { [x: string]: number };
}

export default function WeektableWeekTotalCell(props: IWeektableWeekTotalCellProps) {
    return (
        <div className="text-center font-semibold text-xs w-full text-(--colorNeutralForeground1)">
            {props.weekTotal[props.projectID] || "0"}
        </div>
    );
}
